export const COUPON_EXPIRY = {
  COUPON_EXPIRY_TEXT: 'Expires in',
  OFFER_EXPIRY_TEXT: 'Offer expires in',
  APPLIED_OFFER_EXPIRING: 'Applied offer expires in',
  EXPIRED_TIMER_TEXT: '00s',
};
